export { default } from "./SendMessageController.vue";
